module.exports = __webpack_public_path__ + "img/MX.40b30a81.png";